import React, { useEffect, useState } from 'react';
import authService from '../../api/authService';

const ApiKeysPage = () => {
  const [loading, setLoading] = useState(false);
  const [keys, setKeys] = useState([]);
  const [newKeyName, setNewKeyName] = useState('');
  const [latestKey, setLatestKey] = useState('');

  const fetchKeys = async () => {
    try {
      setLoading(true);
      const res = await authService.getApiKeys();
      if (res.success) setKeys(res.data || []);
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchKeys();
  }, []);

  const handleCreate = async () => {
    try {
      const res = await authService.createApiKey({ name: newKeyName || 'Default Integration Key' });
      if (res.success) {
        setLatestKey(res.data.apiKey);
        setNewKeyName('');
        fetchKeys();
      }
    } catch (error) {
      alert(error.message);
    }
  };

  const handleRevoke = async (id) => {
    try {
      await authService.revokeApiKey(id);
      fetchKeys();
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="fw-700 mb-1">API Keys</h4>
          <div className="text-muted">Generate secure keys for direct integrations and server-to-server access.</div>
        </div>
      </div>

      <div className="card border-0 shadow-sm mb-4">
        <div className="card-body">
          <div className="row g-3 align-items-end">
            <div className="col-md-6">
              <label className="form-label">Key Name</label>
              <input className="form-control" value={newKeyName} onChange={(e) => setNewKeyName(e.target.value)} placeholder="CRM Integration Key" />
            </div>
            <div className="col-md-3">
              <button className="btn btn-primary w-100" onClick={handleCreate}>Generate API Key</button>
            </div>
          </div>
          {latestKey && (
            <div className="alert alert-warning mt-3 mb-0">
              <div className="fw-600 mb-1">Copy this key now. It will not be shown again.</div>
              <code>{latestKey}</code>
            </div>
          )}
        </div>
      </div>

      <div className="card border-0 shadow-sm">
        <div className="card-body">
          {loading ? (
            <div className="text-muted">Loading keys...</div>
          ) : (
            <div className="table-responsive">
              <table className="table align-middle">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Prefix</th>
                    <th>Created</th>
                    <th>Last Used</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {keys.length > 0 ? keys.map((key) => (
                    <tr key={key._id}>
                      <td>{key.name}</td>
                      <td><code>{key.prefix}</code></td>
                      <td>{key.createdAt ? new Date(key.createdAt).toLocaleString() : 'N/A'}</td>
                      <td>{key.lastUsedAt ? new Date(key.lastUsedAt).toLocaleString() : 'Never'}</td>
                      <td className="text-end">
                        <button className="btn btn-sm btn-outline-danger" onClick={() => handleRevoke(key._id)}>Revoke</button>
                      </td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan="5" className="text-center text-muted py-4">No API keys created yet.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ApiKeysPage;
